import { useQuery } from "@tanstack/react-query";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { MODEL_PROVIDERS_QUERY_KEY, toConfiguredModelProvider } from "./fetchModelProviders";
const fetchModelProvider = (provider) => AIConfiguredModelProviders.getConfiguredProvider(provider).then((response) => {
  var _a;
  return {
    ...toConfiguredModelProvider(response),
    used_by: (_a = response.used_by) != null ? _a : []
  };
});
const useModelProvider = (provider) => {
  const { data, isLoading } = useQuery({
    queryKey: [...MODEL_PROVIDERS_QUERY_KEY, "details", provider],
    queryFn: () => defaultOnError(fetchModelProvider(provider), "Loading model provider failed", "Could not load model provider")
  });
  return { data, isLoading };
};
export default useModelProvider;
